// import React, { createContext, useState, useEffect } from "react";
// import { db } from "../firebase/firebase"; // Firestore config
// import { collection, onSnapshot } from "firebase/firestore";

// // Context create karo
// export const BannerContext = createContext();

// export const BannerProvider = ({ children }) => {
//   const [banners, setBanners] = useState([]);
//   const [isLoading, setIsLoading] = useState(true); // Add loading state

//   useEffect(() => {
//     // Check if banners are already cached in localStorage
//     const cachedBanners = localStorage.getItem("cachedBanners");
//     if (cachedBanners) {
//       setBanners(JSON.parse(cachedBanners));
//       setIsLoading(false); // Use cached data, stop loading
//     }

//     // Fetch fresh data from Firestore
//     const unsubscribe = onSnapshot(collection(db, "banners"), (snapshot) => {
//       const bannerList = snapshot.docs.map((doc) => doc.data().url);
//       setBanners(bannerList);
//       localStorage.setItem("cachedBanners", JSON.stringify(bannerList));
//       setIsLoading(false); // Data fetched, stop loading
//     });

//     return () => unsubscribe(); // Cleanup on unmount
//   }, []);

//   return (
//     <BannerContext.Provider value={{ banners, isLoading }}>
//       {children}
//     </BannerContext.Provider>
//   );
// };


import React, { createContext, useState, useEffect } from "react";
import { db } from "../firebase/firebase"; // Firestore config
import { collection, onSnapshot } from "firebase/firestore";

// Create a generic context
export const BannerContext = createContext();

export const BannerProvider = ({ children, collectionName }) => {
  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const cachedBanners = localStorage.getItem(`cachedBanners_${collectionName}`);
    if (cachedBanners) {
      try {
        const parsedBanners = JSON.parse(cachedBanners);
        if (Array.isArray(parsedBanners) && parsedBanners.length > 0) {
          setBanners(parsedBanners);
          setIsLoading(false);
        } else {
          localStorage.removeItem(`cachedBanners_${collectionName}`); // Invalid cache remove
        }
      } catch (error) {
        console.error("Invalid local storage data:", error);
        localStorage.removeItem(`cachedBanners_${collectionName}`); // Corrupt data reset
      }
    }
  
    // Fetch fresh data
    const unsubscribe = onSnapshot(collection(db, collectionName), (snapshot) => {
      const bannerList = snapshot.docs.map((doc) => doc.data().url)
      .filter((url) => typeof url === "string" && url.trim() !== "");
      
      if (bannerList.length > 0) {
        setBanners(bannerList);
        localStorage.setItem(`cachedBanners_${collectionName}`, JSON.stringify(bannerList));
      }
      setIsLoading(false);
    });
  
    return () => unsubscribe();
  }, [collectionName]);
  
  // useEffect(() => {
  //   // Check if banners are already cached in localStorage
  //   const cachedBanners = localStorage.getItem(`cachedBanners_${collectionName}`);
  //   if (cachedBanners) {
  //     setBanners(JSON.parse(cachedBanners));
  //     setIsLoading(false); // Use cached data, stop loading
  //   }

  //   // Fetch fresh data from Firestore
  //   const unsubscribe = onSnapshot(collection(db, collectionName), (snapshot) => {
  //     const bannerList = snapshot.docs.map((doc) => doc.data().url);
  //     setBanners(bannerList);
  //     localStorage.setItem(`cachedBanners_${collectionName}`, JSON.stringify(bannerList));
  //     setIsLoading(false); // Data fetched, stop loading
  //   });

  //   return () => unsubscribe(); // Cleanup on unmount
  // }, [collectionName]); // Re-run effect when collectionName changes

  return (
    <BannerContext.Provider value={{ banners, isLoading }}>
      {children}
    </BannerContext.Provider>
  );
};